<template>
  <div class="main">
    <h2 class="title">动态海报</h2>
    <hr/>
    <h3 class="clm_title">关联活动：
        <el-select v-model="related_id" placeholder="请选择活动名称" :disabled="poster_id">
            <el-option v-for="(item,index) in activity_list" :key="index" :label="item.name" :value="item.id" ></el-option>
        </el-select>
    </h3>
    <el-upload class="upload-demo" :show-file-list="false" :http-request="uploadImg" :before-upload="beforeAvatarUpload">
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
    <!--  -->
    <el-image class="up-image" :src="posters_src">
      <div slot="placeholder" class="image-slot">
        加载中<span class="dot">...</span>
      </div>
      <div slot="error" :style="{height:posters_src?'':'150px','line-height':posters_src?'':'150px'}" class="image-slot error">
        请上传图片...
      </div>
    </el-image>
    <!-- 用户头像 -->
    <div class="radio-group">
      <el-checkbox v-model="headimg_checkbox">用户头像</el-checkbox>
      大小
      <el-input class="size" v-model="headimg_size" :disabled="!headimg_checkbox"></el-input>px
      <div class="right">
        左上角坐标
        <el-input placeholder="X" v-model="headimg_x" :disabled="!headimg_checkbox"></el-input>
        <el-input placeholder="Y" v-model="headimg_y" :disabled="!headimg_checkbox"></el-input>
      </div>
    </div>
    <!-- 用户昵称 -->
    <div class="radio-group">
      <el-checkbox v-model="nickname_checkbox">用户昵称</el-checkbox>
      大小
      <el-input class="size" v-model="nickname_size" :disabled="!nickname_checkbox"></el-input>px
      <div class="right">
        左下角坐标
        <el-input placeholder="X" v-model="nickname_x" :disabled="!nickname_checkbox"></el-input>
        <el-input placeholder="Y" v-model="nickname_y" :disabled="!nickname_checkbox"></el-input>
      </div>
      颜色
      <el-input class="size" v-model="nickname_color" :disabled="!nickname_checkbox"></el-input>
      长度
      <el-input class="size" v-model="nickname_maxlen" :disabled="!nickname_checkbox"></el-input>px
      <div class="align">
        对齐方式
      <el-select class="size" v-model="nickname_alignment" placeholder="请选择对齐方式" :disabled="!nickname_checkbox">
        <el-option v-for="(item,index) in alignment_list" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select>
      </div>
    </div>
    <!-- 关键词 -->
    <div class="radio-group">
      <el-checkbox v-model="text_checkbox">关键词</el-checkbox>
      大小
      <el-input class="size" v-model="text_size" :disabled="!text_checkbox"></el-input>px
      <div class="right">
        左下角坐标
        <el-input placeholder="X" v-model="text_x" :disabled="!text_checkbox"></el-input>
        <el-input placeholder="Y" v-model="text_y" :disabled="!text_checkbox"></el-input>
      </div>
      颜色
      <el-input class="size" v-model="text_color" :disabled="!text_checkbox"></el-input>
      <div class="align">
        对齐方式
      <el-select class="size" v-model="text_alignment" placeholder="请选择对齐方式" :disabled="!text_checkbox">
        <el-option v-for="(item,index) in alignment_list" :key="index" :label="item.name" :value="item.id"></el-option>
      </el-select>
      </div>
    </div>
    <hr/>
    <!-- 操作按钮 -->
    <div slot="footer" align="left" class="footer">
      <el-button @click="$router.go(-1)">返 回</el-button>
      <el-button type="primary" @click="validationHandle('submit')">保 存</el-button>
      <el-button type="info" @click="validationHandle('preview')">预 览</el-button>
    </div>
    <!-- 预览海报 -->
    <el-dialog :visible.sync="dialogVisible" width="30%">
      <div class="dialog_box">
        <el-image :src="preview_posters">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  isDev,
  isMain
} from "@u/tools";
import {
  poster_get,
  poster_add,
  poster_update,
  poster_preview,
  all_activity
} from "@/api/calendar";
import {
  upload_image,
} from "@/api/lecture_editor";
export default {
  data() {
      return {
        poster_id: null,
        related_id: null,
        related_type: null,
        dialogVisible: false,
        name: '',
        posters_src: '',
        image_id: '',
        headimg_checkbox: false,
        nickname_checkbox: false,
        text_checkbox: false,
        headimg_size: null,
        headimg_x: null,
        headimg_y: null,
        nickname_size: null,
        nickname_x: null,
        nickname_y: null,
        nickname_color: '',
        nickname_maxlen: '',
        nickname_alignment: '',
        text_size: null,
        text_x: null,
        text_y: null,
        text_color: '',
        text_alignment: '',
        preview_posters: '',
        activity_list: [],
        poster_obj: {},
        alignment_list: [{
          id: 1,
          name: '左下'
        }, {
          id: 2,
          name: '中下'
        }, {
          id: 3,
          name: '右下'
        }, {
          id: 4,
          name: '左中'
        }, {
          id: 5,
          name: '中中'
        }, {
          id: 6,
          name: '右中'
        }, {
          id: 7,
          name: '左上'
        }, {
          id: 8,
          name: '中上'
        }, {
          id: 9,
          name: '右上'
        }]
      }
    },
    methods: {
      // 预览
      previewHandle() {
        poster_preview(this.poster_obj)
        .then((data) => {
          this.preview_posters = data.image_url;
          this.dialogVisible = true;
        });
      },
      // 验证
      validationHandle(val) {
        if (!this.image_id || this.activity_id == '') {
          this.$message({
            message: '信息不能为空！',
            type: 'warning'
          });
          return false;
        }

        this.poster_obj = {
          related_id: this.related_id,
          related_type: this.related_type,
          image_id: this.image_id,
          headimg_size: this.headimg_checkbox ? this.headimg_size : 0,
          headimg_x: this.headimg_x ? this.headimg_x : null,
          headimg_y: this.headimg_y ? this.headimg_y : null,
          nickname_size: this.nickname_checkbox ? this.nickname_size : 0,
          nickname_x: this.nickname_x ? this.nickname_x : null,
          nickname_y: this.nickname_y ? this.nickname_y : null,
          nickname_color: this.nickname_color ? this.nickname_color : '',
          nickname_maxlen: this.nickname_maxlen ? this.nickname_maxlen : '',
          nickname_alignment: this.nickname_alignment ? this.nickname_alignment : '',
          text_size: this.text_checkbox ? this.text_size : 0,
          text_x: this.text_x ? this.text_x : null,
          text_y: this.text_y ? this.text_y : null,
          text_color: this.text_color ? this.text_color : '',
          text_alignment: this.text_alignment ? this.text_alignment : '',
        };
        let poster = poster_add;
        if (this.poster_id) {
            this.poster_obj['poster_id'] = this.poster_id;
            poster = poster_update
        }
        val == 'preview' ? this.previewHandle() : this.submitHandle(poster);
      },
      // 提交
      submitHandle(poster) {
        poster(this.poster_obj).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.$notify({
            title: '成功',
            message: '保存海报信息成功！',
            type: 'success'
          });
          this.$router.go(-1);
        }).catch((err) => {
            console.log(err);
          this.$notify({
            title: '失败',
            message: '保存海报信息失败！',
            type: 'error'
          });
        });
      },
      pullData() {
        this.related_id = this.$route.query.related_id?this.$route.query.related_id:'';
        this.poster_id = this.$route.query.poster_id;
        this.related_type = this.$route.query.related_type;
        all_activity()
          .then((data) => {
            this.activity_list = data.list;
          });
        if (!this.poster_id) {
          return
        }
        poster_get({
          poster_id: this.poster_id,
          related_id: this.related_id,
          related_type: this.related_type
        }).then((data) => {
          if (data.item) {
            this.preview_posters = data.item.image_url;
            this.headimg_size = data.item.headimg_size;
            this.headimg_x = data.item.headimg_x;
            this.headimg_y = data.item.headimg_y;
            this.nickname_size = data.item.nickname_size;
            this.nickname_x = data.item.nickname_x;
            this.nickname_y = data.item.nickname_y;
            this.nickname_color = data.item.nickname_color;
            this.nickname_maxlen = data.item.nickname_maxlen;
            this.nickname_alignment = data.item.nickname_alignment;
            this.text_size = data.item.text_size;
            this.text_x = data.item.text_x;
            this.text_y = data.item.text_y;
            this.text_color = data.item.text_color;
            this.text_alignment = data.item.text_alignment;
            this.posters_src = data.item.image_url;
            this.image_id = data.item.image_id;
            this.headimg_checkbox = data.item.headimg_size != 0 ? true : false;
            this.nickname_checkbox = data.item.nickname_size != 0 ? true : false;
            this.text_checkbox = data.item.text_size != 0 ? true : false;
          }
        });
      },
      beforeAvatarUpload(file) {
        const isJPG = true;
        const isLt2M = file.size / 2048 / 2048 < 1;

        if (!file.type === 'image/jpg' || !file.type === 'image/png' || !file.type === 'image/gif') {
          isJPG = false;
          this.$message.error('上传头像图片只能是 jpg/png/gif 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
      },
      uploadImg(param) {
        // FormData 对象
        let form = new FormData();
        // 文件对象
        form.append("image", param.file);
        // 携带当前讲座的id
        form.append("key", this.$route.path + '?related_id=' + this.related_id);
        form.append("preserve", 1);

        // 上传图片接口
        upload_image(form).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.posters_src = data.image_url;
          this.image_id = data.image_id;
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.main {
  // width: 800px;
  margin: 20px auto auto;
  background-color: #ffffff;
  color: #333333;
  padding: 30px 50px;
  h2.title {
    font-size: 16px;
    font-weight: normal;
  }
  .clm_title {
    font-size: 14px;
    font-weight: bold;
    margin: 30px auto;
    span {
      font-weight: normal;
    }
  }
  .up-image {
    margin: 30px auto;
    width: 187.5px;
    text-align: center;
    border-radius: 8px;
    // line-height: 250px;
    .error {
      border-radius: 8px;
      background-color: rgba($color: #eeeeee, $alpha: .5);
    }
  }
  .radio-group {
    margin-bottom: 30px;
    .el-checkbox {
      width: 100px;
    }
    .right {
      display: inline-block;
      margin-left: 20px;
      .el-input {
        width: 100px;
        margin: auto 10px;
      }
    }
    .el-input.size {
      width: 100px;
      margin: auto 20px;
    }
  }
  .dialog_box {
    background-color: #ffffff;
    text-align: center;
    img {
      width: 375px;
      // height: 667px;
    }
  }
  .footer {
    margin-top: 20px;
  }
}
.align {
  margin-top: 20px;
  margin-left: 106px;
  .size {
    margin-left: 20px;
  }
}
</style>
